import { useEffect } from "react";

const useMountEffect = (fn) => {
  // eslint-disable-next-line react-custom/no-use-effect-in-hooks, react-hooks/exhaustive-deps
  useEffect(fn, []);
};

export default useMountEffect;
